@if (loading()) {
<div class="flex flex-col items-center justify-center p-12 gap-4 text-gray-400">
<div class="w-10 h-10 border-4 border-gray-200 border-t-secondary rounded-full animate-spin"></div>
<p>Chargement du produit...</p>
</div>
}

@if (error() && !loading()) {
<div class="flex flex-col items-center justify-center p-12 gap-4 text-gray-400">
<p>❌ Impossible de charger le produit.</p>
<button class="text-orange-600 font-semibold text-sm bg-none border-none cursor-pointer" (click)="cancel()">Fermer
</button>
</div>
}

@if (product && !loading() && !error()) {
<div class="px-5 py-4 border-b border-gray-100 sticky top-0 z-10">
<div class="flex items-center gap-3.5">
<img [src]="product.image" [alt]="product.name"
class="w-16 h-16 object-cover rounded-xl border-2 border-gray-100"
onerror="this.src='assets/placeholder.webp'"/>
<div>
<h2 class="text-lg font-bold text-base mb-1">{{ product.name }}</h2>
@if (isFree()) {
<span
  class="inline-block bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">
              🎁 Gratuit
            </span>
}
@if (!isFree() && getDiscountBadge()) {
<span
  class="inline-block bg-orange-50 text-orange-600 text-xs font-semibold px-2.5 py-0.5 rounded-full">
              {{ getDiscountBadge() }} de réduction
            </span>
}
</div>
</div>
</div>
<mat-dialog-content>
<div class="flex flex-col gap-6 flex-1">
@if (product.ingredients?.length) {
<div class="flex flex-col gap-3">
  <h3 class="text-[0.95rem] font-bold text-site m-0">
    Composition : Décochez si un ingrédient ne vous convient pas 😋😜
  </h3>
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
    @for (ing of product.ingredients; track ing) {
    <label
      class="flex items-center gap-2.5 px-3.5 py-2.5 border-gray-200 rounded-xl label transition-all"
      [class.opacity-45]="!isIngredientSelected(ing.id)"
      [class.border-gray-200]="!isIngredientSelected(ing.id)"
      [class.bg-gray-50]="!isIngredientSelected(ing.id)"
      [class.cursor-not-allowed]="ing.required"
      [class.cursor-pointer]="!ing.required">

      <mat-checkbox
        [checked]="isIngredientSelected(ing.id)"
        [disabled]="ing.required"
        (change)="toggleIngredient(ing.id)">
      </mat-checkbox>

      <div class="flex-1 min-w-0 flex items-center flex-wrap gap-2">
        <span class="text-sm font-medium">{{ ing.name }}</span>
            @if (ing.required) {
    <span class="bg-[#15803D] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] whitespace-nowrap">
                Obligatoire
              </span>
    }
    </div>

    <img [src]="ing.image" [alt]="ing.name"
      class="w-11 h-11 object-cover rounded-md"
      onerror="this.style.display='none'"/>
  </label>
    }
  </div>
</div>
}
@if (getFilteredAdditions().length) {
<div class="flex flex-col gap-3">
  <h3 class="text-[0.95rem] font-bold text-site m-0">
    Choisissez vos accompagnements 🍗🥦🧀🥣🍹
  </h3>
  @for (addition of getFilteredAdditions(); track addition.id) {
  <div [attr.id]="'addition-' + addition.id">
    <div class="flex items-center gap-2 mb-2 flex-wrap">
      <span class="text-[0.9rem] font-bold text-site">{{ getAdditionTitle(addition) }}</span>
                      <span class="text-xs text-gray-400">
                        ({{ addition.required ? 'Obligatoire' : 'Optionnel' }}
  - {{ getTotalAccQty(addition.id) }}/{{ addition.quantity }} choix)
                      </span>
                    </div>
                    <div class="flex flex-col gap-2">
                      @for (item of addition.items; track item) {
  <div
    class=" relative flex items-center gap-3 px-3.5 py-2.5 rounded-xl label transition-all"
    [class.border-orange-500]="getAccQty(addition.id, item.id) > 0"
    [class.bg-orange-50]="getAccQty(addition.id, item.id) > 0"
    [class.border-gray-200]="getAccQty(addition.id, item.id) === 0"
    [class.opacity-60]="item.available === false"
    [class.cursor-not-allowed]="item.available === false"
    [class.cursor-pointer]="item.available === true">
    @if (item.available === false) {
    <span
      class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
      Non disponible
    </span>
    }
    <span class="flex-1 text-sm font-medium">
                            {{ item.name }}
      @if (item.price) {
      <small class="text-gray-400 text-xs">
        (+{{ parseSupPrice(item.price) | number:'1.2-2' }} €)
                              </small>
                            }
                          </span>
    <div class="flex items-center gap-2.5">
      <button
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="decreaseAccById(addition.id, item.id)"
        [disabled]="getAccQty(addition.id, item.id) === 0">-
      </button>
      <span class="font-bold min-w-[20px] text-center">{{ getAccQty(addition.id, item.id) }}</span>
      <button
        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="increaseAccById(addition.id, item.id, addition.quantity)"
        [disabled]="getTotalAccQty(addition.id) >= addition.quantity || item.available === false ">+
      </button>
    </div>
    @if (item.image) {
    <img [src]="item.image" [alt]="item.name"
      class="w-11 h-11 object-cover rounded-md"
      onerror="this.style.display='none'"/>
    }
  </div>
  }
  </div>
</div>
  }
</div>
}
@if (product.supplements?.length) {
<div class="flex flex-col gap-3">
  <h3 class="text-[0.95rem] font-bold text-site m-0">
    Ingrédients Supplémentaires 🍟🧀🍗
  </h3>
  <!-- ✅ Boucle par catégorie -->
  @for (category of getSupplementCategories(); track category) {
  <div class="flex flex-col gap-2">
    <p class="text-sm font-semibold text-site">{{ category }}</p>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      @for (sup of supplementsByCategory[category]; track sup) {
  <label
    class="flex items-center gap-2.5 px-3.5 py-2.5 rounded-xl cursor-pointer label transition-all"
    [class.border-orange-500]="isSupplementChecked(sup.id)"
    [class.bg-orange-50]="isSupplementChecked(sup.id)"
    [class.border-gray-200]="!isSupplementChecked(sup.id)">
    <mat-checkbox
      [checked]="isSupplementChecked(sup.id)"
      (change)="toggleSupplementById(sup)"
    >
    </mat-checkbox>
    <span class="flex-1 text-[0.82rem] font-medium">
                              {{ sup.name }}
      @if (getSupplementPrice(sup) > 0) {
      <small class="text-primary font-semibold">
        (+{{ getSupplementPrice(sup) | number:'1.2-2' }} €)
                                </small>
                              }
                            </span>
    @if (sup.image) {
    <img [src]="sup.image" [alt]="sup.name"
      class="w-11 h-11 object-cover rounded-md"
      onerror="this.style.display='none'"/>
    }
  </label>
  }
  </div>
</div>
  }
</div>
}
</div>
</mat-dialog-content>
<div class="flex flex-col gap-2 px-4 pb-4">
<!-- ← AJOUTER : Message de validation -->
@if (getValidationMessage()) {
<div
  class="bg-orange-50 border border-orange-300 rounded-lg px-3 py-2 text-sm text-orange-700 font-medium text-center">
  ⚠️ {{ getValidationMessage() }}
</div>
}
<div class="flex justify-center gap-2.5">
<button
[matButton]="themeConfig.appearance.button.cancel"
class="flex-1 py-2.5"
(click)="cancel()">
Annuler
</button>
<button
[matButton]="themeConfig.appearance.button.action"
class="flex-1 py-2.5"
(click)="confirm()"
[disabled]="!isConfigurationValid()">
✓ Confirmer
</button>
</div>
</div>
<!--  <div class="flex jutsify-center gap-2.5 px-4 pb-4">-->
<!--    <button-->
<!--      class="flex-1 py-2.5 ion-all"-->
<!--      (click)="cancel()">-->
<!--      Annuler-->
<!--    </button>-->
<!--    <button-->
<!--      class="flex-1 py-2.5 px-5 border-none bg-orange-600 text-white rounded-lg text-sm font-bold cursor-pointer hover:bg-orange-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-all"-->
<!--      (click)="confirm()"-->
<!--      [disabled]="!isConfigurationValid()">-->
<!--      ✓ Confirmer-->
<!--    </button>-->
<!--  </div>-->
}
